module.exports = __webpack_public_path__ + "img/zqcy_logo.9d45894f.jpg";